export const WORKSPACE_ACTIONS = {
  WorkspaceUpdated: 'WorkspaceUpdated'
} as const;
export type WorkspaceActionType = keyof typeof WORKSPACE_ACTIONS;

export const ACCOUNT_ACTIONS = {
  AccountCreated: 'AccountCreated',
  AccountUpdated: 'AccountUpdated',
  AccountDeleted: 'AccountDeleted'
} as const;

export type AccountActionType = keyof typeof ACCOUNT_ACTIONS;

export const PROJECT_ACTIONS = {
  ProjectCreated: 'ProjectCreated',
  ProjectUpdated: 'ProjectUpdated',
  ProjectMemberCreated: 'ProjectMemberCreated',
  ProjectMemberUpdated: 'ProjectMemberUpdated',
  ProjectMemberDeleted: 'ProjectMemberDeleted',
  ProjectMetadataCreated: 'ProjectMetadataCreated',
  ProjectMetadataUpdated: 'ProjectMetadataUpdated',
  ProjectMetadataDeleted: 'ProjectMetadataDeleted'
} as const;
export type ProjectActionType = keyof typeof PROJECT_ACTIONS;

export const ASSET_ACTIONS = {
  AssetCreated: 'AssetCreated',
  AssetUpdated: 'AssetUpdated',
  AssetDeleted: 'AssetDeleted',
  AssetPreviewed: 'AssetPreviewed',
  AssetDownloaded: 'AssetDownloaded',
  AssetTrashed: 'AssetTrashed',
  AssetRestored: 'AssetRestored',
  AssetMetadataCreated: 'AssetMetadataCreated',
  AssetMetadataUpdated: 'AssetMetadataUpdated',
  AssetMetadataDeleted: 'AssetMetadataDeleted'
} as const;
export type AssetActionType = keyof typeof ASSET_ACTIONS;

export const FOLDER_ACTIONS = {
  FolderCreated: 'FolderCreated',
  FolderUpdated: 'FolderUpdated',
  FolderDownloaded: 'FolderDownloaded',
  FolderDeleted: 'FolderDeleted',
  FolderTrashed: 'FolderTrashed',
  FolderRestored: 'FolderRestored'
} as const;
export type FolderActionType = keyof typeof FOLDER_ACTIONS;

export const SHARE_ACTIONS = {
  ShareCreated: 'ShareCreated',
  ShareDeleted: 'ShareDeleted',
  CommentCreated: 'CommentCreated',
  CommentUpdated: 'CommentUpdated',
  CommentDeleted: 'CommentDeleted',
  /** Not implemented, currently detect by `CommentCreated` + its `resolution` attribute */
  CommentResolved: 'CommentResolved',
  ApprovalCreated: 'ApprovalCreated',
  ApprovalUpdated: 'ApprovalUpdated',
  /** Not implemented */
  ApprovalDeleted: 'ApprovalDeleted'
} as const;
export type ShareActionType = keyof typeof SHARE_ACTIONS;

export const CONTRACT_ACTIONS = {
  ContractCreated: 'ContractCreated',
  ContractUpdated: 'ContractUpdated',
  ContractDeleted: 'ContractDeleted',
  ContractExpires: 'ContractExpires',
  ContractExpired: 'ContractExpired',
  ContractLinked: 'ContractLinked',
  ContractUnlinked: 'ContractUnlinked'
} as const;
export type ContractActionType = keyof typeof CONTRACT_ACTIONS;

export const EXPORT_ACTIONS = {
  ExportSuccess: 'ExportSuccess',
  ExportFailed: 'ExportFailed'
} as const;
export type ExportActionType = keyof typeof EXPORT_ACTIONS;

export type ActivityAction =
  | WorkspaceActionType
  | AccountActionType
  | FolderActionType
  | AssetActionType
  | ProjectActionType
  | ShareActionType
  | ContractActionType
  | ExportActionType;
